// http://www.wheresrhys.co.uk/fetch-mock/api
import packMock from '@/utils/packMock';
import auth from './auth';
import crud from './crud';
import products from './products';
import fieldcheck from './fieldcheck';
import tree from './tree';
import datatable from './datatable';
import charts from './charts';
import formData from './form';
/**
 * 加载mock文件
 * packMock(mock1[,mock2])
 */
packMock(
  auth,
  crud,
  tree,
  datatable,
  charts,
  formData,
  fieldcheck
//products
);